import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryLiveStock } from "./BaseApi";

export const livestockBaseApi = createApi({
    reducerPath: 'livestock-api',
    baseQuery: baseQueryLiveStock,
    endpoints: () => ({})
});
